import { message } from 'antd';
import React, { useEffect } from 'react'
import { Route, Redirect, useHistory } from 'react-router-dom'
import { isLogin } from '../../utils/LoginUtil'

export default function AuthRoute(props) {
    const history = useHistory();
    let path = history.location.pathname; // 浏览器输入的路径
    let Component = props.component;

    let allMenuPath = sessionStorage.allMenuPath; // 所有菜单的前端路径
    let userMenuPath = sessionStorage.userMenuPath; // 用户菜单的前端路径

    useEffect(() => {
        // console.log("auth route get isLogin:", isLogin());
        // console.log("auth route get path:", path);

        // console.log('allMenuPath:', allMenuPath);
        // console.log('userMenuPath:', userMenuPath);

        // 拦截用户没有权限的菜单页面
        if (allMenuPath && userMenuPath) {
            let a = allMenuPath.split(',');
            let u = userMenuPath.split(',');
            // 求差集，需要拦截的路径
            let interceptUrl = a.concat(u).filter(v => !u.includes(v))
            // console.log('interceptUrl:', interceptUrl);
            let url = path.replace('/view', '');
            // console.log('url:', url);

            // 遍历比较，符合则拦截
            for (let iu of interceptUrl) {
                // console.log('iu:', iu);
                if (iu == url) {
                    history.push('/view/bill/add')
                }
            }
        }


    }, [history, path])


    return (
        <Route path={path} render={() => {
            return (isLogin()
                ? < Component />
                : <Redirect from={path} to='/login' />);
        }} exact={props.exact} />
    )
}
